/* eslint-disable no-restricted-syntax -- disabled opacity/pointer-events are applied conditionally */
import type { FC, MouseEventHandler } from "react";
import type { ColorType } from "@UI/types/colors.ts";
import type { IconNameType } from "@UI/types/icons.ts";
import DIcon from "@UI/components/Atoms/Icon/DIcon.tsx";
import classNames from "classnames";

interface Props {
  /** Icon to render — defaults to the clear "close" icon. */
  icon?: IconNameType;
  size?: "small" | "medium";
  color?: ColorType | "inherit";
  disabled?: boolean;
  onClick?: MouseEventHandler;
  onMouseDown?: MouseEventHandler;
  className?: string;
  ariaLabel?: string;
}

const DClearButton: FC<Props> = ({
  icon = "close",
  size = "medium",
  color = "neutral-600",
  disabled,
  onClick,
  onMouseDown,
  className,
  ariaLabel = "Clear",
}) => {
  return (
    <button
      type="button"
      className={classNames(
        "d-clear-button d-flex d-align-center d-justify-center d-flex-shrink-0 d-hoverable",
        { "d-clear-button--small": size === "small" },
        className,
      )}
      disabled={disabled}
      style={disabled ? { opacity: 0.4, pointerEvents: "none" } : undefined}
      onClick={onClick}
      onMouseDown={onMouseDown}
      aria-label={ariaLabel}
    >
      <DIcon name={icon} color={color} />
    </button>
  );
};

export default DClearButton;
